import { Modal, TextAlign, useTranslation } from '@nextgen-web-framework/all';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '@nextgen-web-framework/core';
import { updateRegistrationData } from '@commerce-profile-webcomponents/sdk';
import styles from './RegistrationErrorModal.module.scss';

const RegistrationErrorModal = () => {
  const t = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const closeModal = () => {
    dispatch(
      updateRegistrationData({
        isErrorModalOpen: false,
      }),
    );
  };
  return (
    <div className={styles['registration-error-modal']} data-testid="registration-error-modal-container">
      <Modal
        headline={t('profile.SinglePageRegistrationStep.errorModalHeading')}
        primaryButtonLabel={t('profile.SinglePageRegistrationStep.errorModalButton')}
        onPrimaryButtonClick={closeModal}
        onClose={closeModal}
        textAlign={TextAlign.CENTER}
        data-testid="registration-error-modal"
      >
        <div className={styles['registration-error-modal-text']} data-testid="registration-error-modal-text">
          {t('profile.SinglePageRegistrationStep.errorModalText')}
        </div>
      </Modal>
    </div>
  );
};

export default RegistrationErrorModal;
